export interface MediaGalleryItemChangeEventDetail {
    disabled?: boolean,
    fullscreen?: boolean,
    loaded?: boolean
}

export interface MediaGalleryItemControlEventDetail {
    action: 'pause' | 'play',
    fullscreen?: boolean
}

export enum MediaPlayerStatus {
    LOADING = 'LOADING',
    READY = 'READY',
}
